import { Component } from '@angular/core';

@Component({
  selector: 'app-requestform-home',
  templateUrl: './requestform-home.component.html',
  styleUrls: ['./requestform-home.component.scss']
})
export class RequestformHomeComponent {
  loginUser : any
  ngOnInit(): void {
   this.loginUser = localStorage.getItem('username');


  }
}
